import { useMemo } from 'react';

import { toAppClientId, useGetAppClient, useListAppClients } from '@/hooks/api';

export const useGetAppClientWithSecret = () => {
  const { data: appClients } = useListAppClients();
  const appClientWithSecret = useMemo(() => appClients?.data?.find((appClient) => appClient.hasSecret), [appClients]);
  return useGetAppClient(toAppClientId(appClientWithSecret?.appClientId), {
    refetchInterval: (query) => (!query.state.data?.clientSecret ? 2000 : undefined),
  });
};
